import {Component, EventEmitter, Input, Output} from "@angular/core";
import {NgIf} from "@angular/common";
import {getAnimationTrigger} from "@utils/animations";
import {environment} from "@env";
import {IconCloseSmallComponent} from "@shared/icons/icon-close-small/icon-close-small.component";

@Component({
    selector: "app-modal",
    standalone: true,
    imports: [NgIf, IconCloseSmallComponent],
    templateUrl: "./modal.component.html",
    styleUrl: "./modal.component.scss",
    animations: [getAnimationTrigger(environment.animation_delay_in_ms.trigger)],
})
export class ModalComponent {
    @Input() isVisible: boolean = false;
    @Input() isHideHeader: boolean = false;
    @Output() onClose: EventEmitter<void> = new EventEmitter<void>();

    public closeModal(): void
    {
        this.onClose.emit();
    }
}
